export function getAvailabilityConfiguration() {
  return {
    company: '0' as '0' | '6',
    experience: 'CLIENT' as 'CLIENT' | 'ADVISOR' | 'EMPLOYEE',
    group: 'EXT3_WEBAPP',
  };
}
